import styled from 'styled-components'
import { Box, useMatchBreakpoints } from 'vvs-uikit'
import { isAfter } from 'date-fns'

export const storageKey = 'defira'

const endDate = new Date('2022-09-08T00:00:00Z')

export const isExpired = () => {
  return isAfter(new Date(), endDate)
}

const VisitBtn = styled.a`
  cursor: pointer;
  position: absolute;
  // background: blue;
  width: 43%;
  height: 14%;
  left: 3%;
  bottom: 6%;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 21%;
    left: 1%;
    top: 52%;
    height: 40%;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    // width: 21%;
    // left: 1%;
    // top: 52%;
    // height: 40%;
    // transform: translate(0, -50%);
  }
`

const CloseBtn = styled.div`
  cursor: pointer;
  position: absolute;
  background: transparent;
  background-image: url('/images/vvsMinerMole/close_button.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
  top: 15%;
  right: 6%;

  ${({ theme }) => theme.mediaQueries.sm} {
    top: 50%;
    right: 2%;
    transform: translate(0, -50%);
  }
`

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const StyledCard = styled(Box)`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  height: 120px;
  padding: 0px;
  height: fit-content;
  max-width: 1200px;

  background: ${({ theme }) => theme.colors.secondary};
  position: relative;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 30px;
  margin-right: 30px;
`

export const DefiraBanner = ({ onCloseClick }) => {
  const { isMobile } = useMatchBreakpoints()

  const imgSrc = isMobile ? 'defira_banner_mobile.png' : 'defira_banner_desktop.png'

  return (
    <StyledCard>
      <StyledImage src={`/images/defiraBanner/${imgSrc}`} />
      <VisitBtn href="https://www.defira.com/" target="_blank" rel="noreferrer" />
      <CloseBtn onClick={onCloseClick} />
    </StyledCard>
  )
}
